import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-6" }
const _hoisted_3 = { class: "col-md-6" }
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = { class: "col-md-6" }
const _hoisted_6 = { class: "col-md-12" }
const _hoisted_7 = { class: "col-md-12 mt-7" }
const _hoisted_8 = { class: "card" }
const _hoisted_9 = { class: "card-header border-0 pt-0" }
const _hoisted_10 = { class: "card-title align-items-start flex-column" }
const _hoisted_11 = { class: "card-label fw-bolder fs-3" }
const _hoisted_12 = /*#__PURE__*/_createVNode("i", { class: "fas fa-ellipsis-h" }, null, -1)
const _hoisted_13 = { class: "menu-item-wrapper" }
const _hoisted_14 = { class: "menu-item" }
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-edit" })
], -1)
const _hoisted_16 = { class: "menu-item" }
const _hoisted_17 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-trash" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Select = _resolveComponent("Select")!
  const _component_Input = _resolveComponent("Input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Table = _resolveComponent("Table")!
  const _component_PriceChanging = _resolveComponent("PriceChanging")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Select, {
        name: "siteId",
        target: "siteId",
        label: _ctx.$t('message.SITE'),
        siteId: _ctx.siteId,
        "onUpdate:siteId": _cache[1] || (_cache[1] = ($event: any) => (_ctx.siteId = $event)),
        selectData: _ctx.sites,
        value: _ctx.siteId,
        callEmit: true,
        onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeSite(_ctx.siteId)))
      }, null, 8, ["label", "siteId", "selectData", "value"])
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_Select, {
        name: "taxRul",
        target: "taxRul",
        label: `${_ctx.$t('message.TAX')} ${_ctx.$t('message.RULE')}`,
        taxRul: _ctx.taxRule,
        "onUpdate:taxRul": _cache[3] || (_cache[3] = ($event: any) => (_ctx.taxRule = $event)),
        selectData: _ctx.taxRules,
        value: _ctx.taxRule,
        callEmit: true,
        onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeTax()))
      }, null, 8, ["label", "taxRul", "selectData", "value"])
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_Input, {
        type: "number",
        name: "price",
        label: `${_ctx.$t('message.RETAIL_PRICE')} (${_ctx.$t('message.TAX')} ${_ctx.$t('message.EXCLUDE')})`,
        placeholder: `${_ctx.$t('message.ENTER')} ${_ctx.$t('message.PRICE')}`,
        requiredMsg: `${_ctx.$t('message.PRICE')} ${_ctx.$t('message.IS_REQUIRED')}`,
        price: _ctx.price,
        "onUpdate:price": _cache[5] || (_cache[5] = ($event: any) => (_ctx.price = $event)),
        target: "price",
        value: _ctx.price,
        onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateValue()))
      }, null, 8, ["label", "placeholder", "requiredMsg", "price", "value"])
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_Input, {
        type: "number",
        name: "tax",
        label: `${_ctx.$t('message.RETAIL_PRICE')} (${_ctx.$t('message.TAX')} ${_ctx.$t('message.INCLUDE')})`,
        placeholder: `${_ctx.$t('message.TAX')}`,
        tax: _ctx.tax,
        "onUpdate:tax": _cache[7] || (_cache[7] = ($event: any) => (_ctx.tax = $event)),
        target: "tax",
        value: _ctx.tax,
        disabled: true
      }, null, 8, ["label", "placeholder", "tax", "value"])
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode(_component_el_button, {
        type: "primary",
        class: "mt-2 btn-custom",
        disabled: _ctx.pricebtn,
        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.addPrice())),
        style: {"float":"right"}
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.priceId == undefined ? _ctx.$t('message.SAVE') : _ctx.$t('message.UPDATE')), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, [
          _createVNode("h3", _hoisted_10, [
            _createVNode("span", _hoisted_11, _toDisplayString(`${_ctx.$t('message.PRICES')} ${_ctx.$t('message.LIST')}`), 1)
          ])
        ]),
        _createVNode(_component_Table, {
          columns: _ctx.columns,
          rows: _ctx.prices,
          padding: 5
        }, {
          "cell-price": _withCtx(({ row: item }) => [
            _createTextVNode(_toDisplayString(Number(item?.price).toFixed(2)), 1)
          ]),
          "cell-tax": _withCtx(({ row: item }) => [
            _createTextVNode(_toDisplayString(Number(item?.tax).toFixed(2)), 1)
          ]),
          "cell-actions": _withCtx(({row:item,index:index}) => [
            _createVNode("button", {
              class: "action-btn",
              type: "button",
              onClick: ($event: any) => (_ctx.dropdownHandler(_ctx.activeIndex, item?.id, _ctx.deleteValue))
            }, [
              _hoisted_12,
              _createVNode("div", {
                class: ["dropdown-menu dropdown-menu-end action-dropdown", { active: _ctx.activeIndex === item?.id }]
              }, [
                _createVNode("div", _hoisted_13, [
                  _createVNode("div", _hoisted_14, [
                    _createVNode("a", {
                      onClick: ($event: any) => (_ctx.handleEdit(index)),
                      class: "menu-link me-1"
                    }, [
                      _hoisted_15,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('message.EDIT')), 1)
                    ], 8, ["onClick"])
                  ]),
                  _createVNode("div", _hoisted_16, [
                    _createVNode("a", {
                      onClick: ($event: any) => (_ctx.handleDelete(index)),
                      class: "menu-link me-1"
                    }, [
                      _hoisted_17,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('message.DELETE')), 1)
                    ], 8, ["onClick"])
                  ])
                ])
              ], 2)
            ], 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["columns", "rows"])
      ])
    ]),
    _createVNode(_component_PriceChanging)
  ]))
}